import styled from 'styled-components';
import { EmptyStateFind } from 'ui/illustrations';
import { EmptyState } from 'ui/emptyState';
import { spacing } from 'ui/theme';

export const TEXT = {
  PAGE_TITLE_SUFFIX: 'subscription channels',
  UNAUTHORIZED_TITLE: 'Update your permission to view Channels',
  UNAUTHORIZED_SUBTITLE:
    'Ask your project administrator to add Manage Integrations to your role. Learn more about custom roles and permissions.',
  UNATHORIZED_ID: 'unathorized-channels-page',
};

const Container = styled.div`
  padding-top: ${spacing.double};
  padding-bottom: ${spacing.double};
`;

export const UnauthorizedPage = () => (
  <Container>
    <EmptyState
      data-test={TEXT.UNATHORIZED_ID}
      Illustration={EmptyStateFind}
      title={TEXT.UNAUTHORIZED_TITLE}
      subtitle={TEXT.UNAUTHORIZED_SUBTITLE}
    />
  </Container>
);
